<script>
	import { currency_formatter } from '../globals';
	import { onMount } from 'svelte';
	import Header from "../components/Header.svelte";
	import Modal from '../utils/Modal.svelte';
	import breakpoints from "../utils/breakpoints";
	import GoogleMap from "../utils/GoogleMap.svelte";
	import {
	  api_host,
	  // price_setting_store,
	  user_store
	} from "../stores.js";
	import { init_data } from '../init.js';
	import Loading from '../components/Loading.svelte';
	import { getToken, doFetch } from "../utils/Fetching.js";
	import { toast_message } from '../utils/toast_message.js';
	import { formatPhoneNumber, formatDateAndTime, jobStatsToNum, getFullState, formatDate } from '../utils/format.js';
	import Clipboard from "svelte-clipboard";
	import Swal from "sweetalert2";
	import { navigate } from 'svelte-routing';


	export let params = {};
	const { auth_type, auth_token, domain_code } = getToken();
	const bp = breakpoints();
	let job = {};
	let all_crews = [];
	let not_assigned_crews = [];
	let jid = "";
	let is_busy = false;
	let price_setting = {};
	let is_loaded = false;
	let payment_status = true;
	let myself = {};
	let hours = 0;
	let notes = '';

	// photo popup modal
	let modal_photo_popup = false;
	let selected_photo = null;
	let photos = [], fileinput;

	const onFileSelected = (e) => {
		const files = Array.from(e.target.files);
		files.forEach(file => {
			console.log('file', file);

			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = e => {
				let image = new Image();
				image.src = e.target.result;
				image.onload = () => {

					let canvas = document.createElement('canvas');
					let context = canvas.getContext('2d');

					// Set the canvas dimensions to the desired downscaled size
					let downscaledWidth = 400; // Adjust to your desired width
					let downscaledHeight = (image.height / image.width) * downscaledWidth;
					canvas.width = downscaledWidth;
					canvas.height = downscaledHeight;

					// Draw the image onto the canvas with the downscaled size
					context.drawImage(image, 0, 0, downscaledWidth, downscaledHeight);

					// Convert the downscaled image on the canvas to a base64 data URL with reduced quality
					let downscaledDataURL = canvas.toDataURL('image/jpeg', 0.8); // Adjust quality as needed

					photos = [
							...photos, 
							{
									filename: file.name,
									body: downscaledDataURL
							}
					];
					console.log('downgraded', photos);

					updateJob();
				}
			};
		});
	};

	const onFileRemoved = async (index) => {
		const result = await Swal.fire({
			title: "Are you sure you want to delete this photo?",
			text: '',
			buttonsStyling: true,
			confirmButtonClass: "button",
			confirmButtonText: 'Ok',
			cancelButtonText: "Cancel",
			showCancelButton: true,
			icon: "warning"
		});
		if (!result.isConfirmed) return;

		const photo = photos[index];
		if (photo.uploaded) {
				photo.deleted = true;
		} else {
				photos.splice(index);
		}
		photos = photos;

		updateJob();
	};

    const upload_images = async (photos, tag) => {
        const urls = [];
        for (let i = 0; i < photos.length; i++) {
            const photo = photos[i];
            const payload = {
                tag,
                image: photo.body,
                filename: photo.filename
            };
            const { auth_type, auth_token, domain_code } = getToken();
            const res = await doFetch(
                `${api_host}/api/upload/image`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.url) urls.push(res.url);
        }
        return urls;
    };

    const remove_image = async (url) => {
        const { auth_type, auth_token, domain_code } = getToken();
        const res = await doFetch(
            `${api_host}/api/upload/image/remove`,
            'POST',
            {
              url
            }, 
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
    };

	user_store.subscribe(value => {
		console.log(value);
	  myself = value;
	});
	// price_setting_store.subscribe(value => {
	// 		price_setting = value;
	// });

	$: is_employee_exists = (job.crew_users || []).filter(item => item.role === 'employee' || item.role === 'landscaper').length > 0;

	const refresh_job = async (jid) => {
	  const res = await doFetch(`${api_host}/api/job/get/${jid}`, 'GET', null, {
	    Authorization: `${auth_type} ${auth_token}`,
	    'DomainCode': domain_code,
	    'Content-Type': 'application/json'
	  });
	  if (res.status) {
	    job = res.job;
			hours = job.hours;
			notes = job.notes;
			photos = (job.photos ?? []).map(url => ({
					uploaded: true,
					deleted: false,
					body: url
			}));
			console.log(formatDate(job.service_date), formatDate(new Date()));
	    if (job.status === 'unpaid') {
	      payment_status = false;
	    }
	  } else {
	    if (res.msg === 'Job not found') {
				navigate('/jobs');
	    }
	    toast_message(false, res.msg || 'Fetching job details failed', 3000);
	  }
	  is_loaded = true;
	}

	onMount(async () => {
	  if (!myself['is_authenticated']) {
	    // e.g. "Pay Now" in the invoice email while logged out: log in first, then come back to this job
	    window.location.href = `/login?redirect=${encodeURIComponent(window.location.pathname)}`;
	    return;
	  }
	  if (params.jid) {
	    jid = params.jid;
	    refresh_job(jid);
	  }
	});

	const updateStatusAction = async (action_id) => {
	  is_busy = true;
	  const res = await doFetch(`${api_host}/api/job/update/status`, 'POST', {
	    job_id: jid,
	    action: action_id,
	    payment_status
	  }, {
	    Authorization: `${auth_type} ${auth_token}`,
	    'DomainCode': domain_code,
	    'Content-Type': 'application/json'
	  });
	  if (res.status) {
	    job.status = res.updated_status;
	    if (job.status === 'assigned') {
	      job.picked_at = formatDateAndTime(res.updated_date);
	    } else if (job.status === 'completed') {
	      job.completed_at = formatDateAndTime(res.updated_date);
	    } else if (job.status === 'approved') {
	      job.approved_at = formatDateAndTime(res.updated_date);
	    } else if (job.status === 'invoiced') {
	      job.invoiced_at = formatDateAndTime(res.updated_date);
	    } else if (job.status === 'charged') {
	      job.charged_at = formatDateAndTime(res.updated_date);
	    }
	    toast_message(true, res.msg, 3000);
	    refresh_job(jid);
	    init_data('jobs');
	  } else {
	    toast_message(false, res.msg || 'Failed updating job status', 3000);
	  }
	  is_busy = false;
	}

	const updateStatus = async (_action) => {
		let title, action;
		if (_action === 'complete') {
			title = 'Job Completed?';
			action = 'complete';
		} else if (_action === 'cancel') {
			title = 'Cancel Job?';
		} else if (_action === 'pay') {
			title = 'Pay Now?';
			action = 'charge';
		} else {
			title = null;
		}
	  is_busy = true;
		if (title) {
			Swal.fire({
				title: title,
				buttonsStyling: true,
				confirmButtonClass: "button",
				confirmButtonText: 'OK',
				cancelButtonText: "Cancel",
				showCancelButton: true,
				icon: "success"
			}).then(async (e) => {
				if (e.isConfirmed) {
					await updateStatusAction(action);
				}
			});
		}
	  is_busy = false;
	}

	let updateJob = async () => {
			if (is_busy) return;

			is_busy = true;
			const urls = [];
			for (let i = 0; i < photos.length; i++) {
					const photo = photos[i];
					if (photo.uploaded) {
							if (photo.deleted) {
									await remove_image(photo.body);
							} else {
									urls.push(photo.body);
							}
					} else {
							const uploadedUrls = await upload_images([photo], 'quote');
							urls.push(uploadedUrls[0]);
					}
			}

			const payload = {
				job_id: job.id,
				photos: urls
			};
			const res = await doFetch(
					`${api_host}/api/job/update/photos`,
					'POST',
					payload,
					{ Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
			);
			if (res.status) {
					refresh_job(job.id);
					init_data('jobs');
					toast_message(true, res.msg, 2000);
			} else {
					toast_message(false, res.msg || 'Bad request', 2000);
			}
			is_busy = false;
	};

	const updateHours = async () => {
		if (is_busy) return;

		is_busy = true;
		const payload = {
			job_id: job.id,
			hours,
			notes
		};
		const res = await doFetch(
			`${api_host}/api/job/update/hours`,
			'POST',
			payload,
			{ Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
		);
		if (res.status) {
				refresh_job(job.id);
				init_data('jobs');
				toast_message(true, res.msg, 2000);
		} else {
				toast_message(false, res.msg || 'Bad request', 2000);
		}
		is_busy = false;
	};

	const showThumbnail = (photo) => {
			selected_photo = photo;
			modal_photo_popup = true;
	}
</script>


<Header />

<div class="formholder">
	<!-- <div class="pagetitle">
		Job Review
	</div> -->

	{#if is_loaded && Object.keys(job).length > 0}
	<div class={`${myself.user.role === 'client' ? 'contentholder' : 'contentholder_crew'}`}>
		{#if myself.plan_type !== 'basic'}
		<div class="buttonholder">
			{#if myself.user.role === 'employee' || myself.user.role === 'contractor'}
				{#if job.status === 'assigned'}
					<button class='action' on:click={() => { updateStatus('complete'); }} disabled={is_busy}>
						Job Completed
					</button>
					<!-- <button class='action' on:click={() => { updateStatus('cancel'); }} disabled={is_busy} style='background-color: #cd4646;'>
						Cancel Job
					</button> -->
				{/if}
			{/if}
			{#if myself.user.role === 'client'}
				{#if job.status !== 'charged' && formatDate(job.service_date) <= formatDate(new Date())}
					<button class='action' on:click={() => { updateStatus('pay'); }} disabled={is_busy}>
						<i class='far fa-file-invoice-dollar'></i>&nbsp;Pay Now
					</button>
				{/if}
			{/if}
			<!-- {#if job.status === 'unpaid' || job.status === 'refunded' || job.status === 'card_declined'}
				<button class="action" on:click={() => { push(`#/Invoice_Review?iid=${job.invoice.invoice_number}`); }} disabled={is_busy} style='background-color: #ff9100;'>
					<i class={`far fa-file-invoice-dollar`}></i>&nbsp;Invoice
				</button>
			{/if} -->
		</div>
		{/if}
		
		<div class="section progress" style="display: inline-table;padding-bottom: 5px;">
				<div class="sectiontitle"><i class="fas fa-stream"></i> Progress</div>
				<div class="progressholder">
						<div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 0 ? ' completed' : '')}>
								<div class="progressiteminfo">1) Created</div>
								<div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 0 ? 'Done' : 'In Progress'}</div>
								<div class="progressitemts">{jobStatsToNum(job.status)[0] >= 1 ? formatDateAndTime(job.created_at) : ''}</div>
						</div>
						<div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>

						<div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 2 ? ' completed' : '')}>
								<div class="progressiteminfo">2) Crew assigned:</div>
								<div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 2 ? 'Done' : 'In Progress'}</div>
								<div class="progressitemts">{jobStatsToNum(job.status)[0] >= 2 ? formatDateAndTime(job.picked_at) : ''}</div>
						</div>
						<div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>

						<div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 3 ? ' completed' : '')}>
								<div class="progressiteminfo">3) Crew completed:</div>
								<div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 3 ? 'Done' : 'In Progress'}</div>
								<div class="progressitemts">{jobStatsToNum(job.status)[0] >= 3 ? formatDateAndTime(job.completed_at) : ''}</div>
						</div>
						<div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>

						<div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 4 ? ' completed' : '')}>
								<div class="progressiteminfo">4) Work approved:</div>
								<div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 4 ? 'Done' : 'In Progress'}</div>
								<div class="progressitemts">{jobStatsToNum(job.status)[0] >= 4 ? formatDateAndTime(job.approved_at) : ''}</div>
						</div>
						<div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>

						<!-- {#if !is_employee_exists}
						<div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 5 ? ' completed' : '')}>
								<div class="progressiteminfo">5) Crew invoiced:</div>
								<div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 5 ? 'Done' : (job.status === 'unpaid' ? 'Open' : 'In Progress')}</div>
								<div class="progressitemts">{jobStatsToNum(job.status)[0] >= 5 ? formatDateAndTime(job.charged_at) : ''}</div>
						</div>
						<div class="progressflowarrow"><i class="fas fa-angle-double-{($bp === "desktop") ? "right" : "down"}"></i></div>
						{/if} -->

						<div class={"progressitem" + (jobStatsToNum(job.status)[0] >= 6 ? ' completed' : '')}>
								<div class="progressiteminfo">5) Client charged:</div>
								<div class="progressitemstatus">{jobStatsToNum(job.status)[0] >= 6 ? 'Done' : (jobStatsToNum(job.status)[0] >= 4 ? jobStatsToNum(job.status)[1] : 'In Progress')}</div>
								<div class="progressitemts">{jobStatsToNum(job.status)[0] >= 6 ? formatDateAndTime(job.charged_at) : ''}</div>
						</div>
				</div>
		</div>

		{#if myself.user.role === 'employee' || myself.user.role === 'landscaper'}
    <div class="section timesheetinfo">
        <div class="sectiontitle"><i class="fal fa-user-hard-hat"></i> Timesheet</div>
        <div class="sectioninfo">
            
            <table>
                <tr>
                    <th>Crew name</th>
                    <th>Hours</th>
                    <th>Notes</th>
                </tr>
                <tr>
                    <td>{ myself.user.first_name }</td>
                    <td><input type="number" bind:value={hours} min="0" style="width: 60px; border-radius: 4px;" disabled={job.status != 'assigned'}></td>
                    <td><textarea rows=1 bind:value={notes} style="border-radius: 4px; margin-top: 6px;" disabled={job.status != 'assigned'}></textarea></td>
                </tr>
            </table>
						{#if job.status === 'assigned'}
						<div style="margin-top: 10px;">
							<button on:click={updateHours} style="background-color: #1769aa; color: white;" disabled={is_busy}>Save</button>
						</div>
						{/if}
        </div>
    </div>
    {/if}
		
		<div class="section pricinginfo">
				<div class="sectiontitle"><i class="fas fa-dollar-sign"></i> Pricing Information</div>

				<div class="sectioninfo">
						<div class="leftcolumn">
								<!-- <div class="infoitem">
										<div class="infoitemtitle">Contractor Price:</div>
										<div class="infoitemvalue">{is_employee_exists ? '-' : `$${parseFloat(job.contractor_price).toFixed(2)}`}</div>
								</div>
								<div class="infoitem">
										<div class="infoitemtitle">Extra Contractor Price:</div>
										<div class="infoitemvalue">{is_employee_exists ? '-' : `$${parseFloat(job.extra_contractor_price).toFixed(2)}`}</div>
								</div> -->
								{#if myself.user.role === 'contractor'}
									<div class="infoitem">
										<div class="infoitemtitle">Contractor Price:</div>
										<div class="infoitemvalue"><b>{is_employee_exists ? '-' : currency_formatter.format(job.total_contractor_price)}</b></div>
									</div>
								{/if}
								
								{#if myself.user.role === 'client'}
									<div class="infoitem">
											<div class="infoitemtitle">Payment Method:</div>
											<div class="infoitemvalue">
													{job.paymethod}
													{#if job.paymethod === 'Credit Card' && !job.paycard}
															<span style="color: red;">(Card info needed)</span>
													{/if}
											</div>
									</div>
									<div class="infoitem">
											<div class="infoitemtitle">Service Price:</div>
											<div class="infoitemvalue">{currency_formatter.format(job.service_price)}</div>
									</div>
									<div class="infoitem">
											<div class="infoitemtitle">Extra Service Price:</div>
											<div class="infoitemvalue">{currency_formatter.format(job.extra_service_price)}</div>
									</div>
									<div class="infoitem">
											<div class="infoitemtitle">Total Service Price:</div>
											<div class="infoitemvalue"><b>{currency_formatter.format(job.total_service_price)}</b></div>
									</div>
									{#if job.service_frequency !== 'One-Time'}
									<div class="infoitem">
											<div class="infoitemtitle">Next Service Price:</div>
											<div class="infoitemvalue">{currency_formatter.format(job.next_service_price)}</div>
									</div>
									{/if}
								{/if}
						</div>
				</div>
		</div>

		{#if myself.user.role === 'client'}
		<div class="section clientinfo">
				<div class="sectiontitle"><i class="fas fa-user"></i> {myself.plan_type === 'basic' ? 'Lead Information' : 'Client Information'}</div>

				<div class="sectioninfo">
						<div class="leftcolumn">
								<div class="infoitem">
										<div class="infoitemtitle">Name:</div>
										<div class="infoitemvalue"><div>{job.profile ? `${job.profile.first_name} ${job.profile.last_name}` : ''}</div></div>
								</div>
						
								<div class="infoitem">
										<div class="infoitemtitle">Address:</div>
										<div class="infoitemvalue">
												{job.profile ? `${job.profile.address}, ${job.profile.city}, ${getFullState(job.profile.state || '')}${job.zipcode ? ', ' + job.zipcode : ''}` : ''}
												&nbsp;
												<Clipboard
														text={job.profile ? `${job.profile.address}, ${job.profile.city}, ${getFullState(job.profile.state || '')}${job.zipcode ? ', ' + job.zipcode : ''}` : ''}
														let:copy
														on:copy={() => { toast_message(true, 'Address Copied', 1000); }}
												>
														<i class="fas fa-copy" style="color: #555555;cursor: pointer;" on:click={copy}></i>
												</Clipboard>
										</div>
								</div>

								<div class="infoitem">
										<div class="infoitemtitle">Email:</div>
										<div class="infoitemvalue">{job.profile.email}</div>
								</div>
						
								<div class="infoitem">
										<div class="infoitemtitle">Home Phone:</div>
										<div class="infoitemvalue">{(job.profile && job.profile.home_phone) ? formatPhoneNumber(job.profile.home_phone) : ''}</div>
								</div>
						
								<div class="infoitem">
										<div class="infoitemtitle">Cell Phone:</div>
										<div class="infoitemvalue">{(job.profile && job.profile.mobile_phone) ? formatPhoneNumber(job.profile.mobile_phone) : ''}</div>
								</div>
						</div>
				</div>
		</div>
		{/if}
		
		<div class="section serviceinfo">
				<div class="sectiontitle"><i class="fas fa-info-circle"></i> Service Information</div>

				<div class="sectioninfo">
						<div class="leftcolumn">
								<div class="infoitem">
										<div class="infoitemtitle">Service Date:</div>
										<div class="infoitemvalue">{formatDate(job.service_date)} - {job.time_preference}</div>
								</div>

								{#if job.service_frequency !== 'One-Time'}
								<div class="infoitem">
										<div class="infoitemtitle">Next Service Date:</div>
										<div class="infoitemvalue">{formatDate(job.next_service_date)} - {job.time_preference}</div>
								</div>
								{/if}
						
								<div class="infoitem">
										<div class="infoitemtitle">Address:</div>
										<div class="infoitemvalue">
												{`${job.address}, ${job.city}, ${getFullState(job.state || '')}${job.zipcode ? ', ' + job.zipcode : ''}`}
												&nbsp;
												<Clipboard
														text={`${job.address}, ${job.city}, ${getFullState(job.state || '')}${job.zipcode ? ', ' + job.zipcode : ''}`}
														let:copy
														on:copy={() => { toast_message(true, 'Address Copied', 1000); }}
												>
														<i class="fas fa-copy" style="color: #555555;cursor: pointer;" on:click={copy}></i>
												</Clipboard>
										</div>
								</div>

								<div class="infoitem">
										<div class="infoitemtitle">Lot Size:</div>
										<div class="infoitemvalue">{job.lot_size ? new Intl.NumberFormat().format(parseInt(job.lot_size)) : '-'} sq ft</div>
								</div>
						</div>

						<div class='rightcolumn'>
								<div class="infoitem">
										<div class="infoitemtitle">Lawn:</div>
										<div class="infoitemvalue">{job.lawn}</div>
								</div>

								<div class="infoitem">
										<div class="infoitemtitle">Last Time Clean Up (days):</div>
										<div class="infoitemvalue">{job.last_service}</div>
								</div>

								<div class="infoitem">
										<div class="infoitemtitle">Service Type:</div>
										<div class="infoitemvalue">{job.service_type}</div>
								</div>
								
								<div class="infoitem">
										<div class="infoitemtitle">Service Frequency:</div>
										<div class="infoitemvalue">{job.service_frequency}</div>
								</div>

								<div class="infoitem">
										<div class="infoitemtitle">Back Yard Entry Instruction:</div>
										<div class="infoitemvalue">{job.back_yard_entry}</div>
								</div>
						</div>
				</div>
				
		</div>

		<!-- <div class="section map">
				<div class="sectiontitle">Map</div>
				<div class="mapholder">
						<GoogleMap
								address={job.address}
								city={job.city}
								state={job.state}
						/>
				</div>
		</div> -->

		{#if myself.user.role === 'client' || job.status === 'charged' || job.status === 'unpaid'}
			{#if (photos ?? []).length > 0}
			<div class="section photoinfo">
					<div class="sectiontitle"><i class="fas fa-info-circle"></i> Photos</div>
					<div class="sectioninfo">
							<div class="photo-list">
									{#each (photos ?? []) as photo}
									<div class="photo-item" on:click="{showThumbnail(photo.body)}">
											<img class="photo" src="{photo.body}" alt="{photo.body}" />
									</div>
									{/each}
							</div>
					</div>
			</div>
			{/if}
		{:else}

			<div class="section photoinfo">
				<div class="sectiontitle"><i class="fas fa-info-circle"></i> Photos</div>
				<div class="sectioninfo">
						<div class="photo-list">
								{#each photos as photo, index}
								{#if !photo.deleted}
								<div class="photo-item">
										<img class="photo" src="{photo.body}" alt="d" on:click="{showThumbnail(photo.body)}" />
										<button on:click={()=>{ onFileRemoved(index); }}><i class="fas fa-trash"></i> Delete</button>
								</div>
								{/if}
								{/each}
						</div>
						<div style="margin: 10px;">
								<button on:click={()=>{fileinput.click();}} style="background-color: #1769aa; color: white;" disabled={is_busy}>Add Photo</button>
								<input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} multiple>
						</div>

				</div>
			</div>
		{/if}

		<div class="section additionalcomments">
			<div class="sectiontitle">Additional Comments</div>
			<div class="sectioninfo">
				<pre>{job.additional_comments || 'None'}</pre>
			</div>
		</div>

		<Modal bind:modal_show={modal_photo_popup} modal_width={window.innerWidth < 600 ? window.innerWidth - 10 : 600} modal_padding=15>
			<div>
					<div style="padding-bottom: 5px; font-size: 18px; font-weight: 500;">Photo</div>
					<img class="photo-thumbnail" src="{selected_photo}" alt="{selected_photo}" />
			</div>
		</Modal>
	</div>
	{:else}
	<Loading />
	{/if}
</div>


<style>
	.formholder {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
	}
	@media (max-device-width: 1024px), (max-width: 1023px) {
		.formholder {
			width: 90%;
		}
	}
	.pagetitle {
		border-bottom: solid 1px #E9E9EC;
		font-size: 3rem;
		font-weight: bold;
	}
	.disable_btn {
		opacity: 0.8;
		pointer-events: none;
		cursor: not-allowed;
	}
	.strikeout {
		text-decoration: line-through;
	}
	.contentholder {
		width: 100%;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		grid-template-rows: auto;
		grid-template-areas: "bh bh bh bh bh bh bh bh bh bh bh bh"
													"si si si si si si si si si si si si"
													"ci ci ci ci ci ci pi pi pi pi pi pi"
													"ac ac ac ac ac ac ma ma ma ma ma ma"
													"pr pr pr pr pr pr pr pr pr pr pr pr"
													"py py py py py py py py py py py py";
		gap: 20px;
	}
	.contentholder_crew {
		width: 100%;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		grid-template-rows: auto;
		grid-template-areas: "bh bh bh bh bh bh bh bh bh bh bh bh"
													"si si si si si si si si si si si si"
													"pi pi pi pi pi pi pi pi pi pi pi pi"
													"ac ac ac ac ac ac ma ma ma ma ma ma"
													"ts ts ts ts ts ts ts ts ts ts ts ts"
													"pr pr pr pr pr pr pr pr pr pr pr pr"
													"py py py py py py py py py py py py";
		gap: 20px;
	}
	.buttonholder {
		width: 100%;
		display: flex;
		flex-direction: row;
		grid-area: bh;
		align-items: center;
	}
	.buttonholder button {
		width: 150px;
		margin-right: 5px;
		margin-top: 10px;
		font-size: 12px;
	}
	.buttonholder button.action {
		background-color: #357a38;
		color: white;
		padding-left: 15px;
		padding-right: 15px;
		width: auto;
	}
	.progress {
		grid-area: pr;
	}
	.progressholder {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
	}
	.infoitem {
		display: flex;
		flex-direction: row;
	}
	.infoitem .infoitemtitle {
		width: 50%;
		font-weight: bold;
		text-align: left;
		overflow-wrap: break-word;
		word-wrap: break-word;
		hyphens: auto;
	}
	.infoitem .infoitemvalue {
		width: 50%;
		text-align: left;
		margin-left: 10px;
		overflow-wrap: break-word;
		word-wrap: break-word;
		hyphens: auto;
	}
	.pricinginfo .sectioninfo {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}
	.pricinginfo .leftcolumn {
		width: 100%;
		display: flex;
		flex-direction: column;
	}
	.serviceinfo .sectioninfo {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}
	.serviceinfo .leftcolumn {
		width: 100%;
		display: flex;
		flex-direction: column;
	}
	.serviceinfo .rightcolumn {
		width: 100%;
		display: flex;
		flex-direction: column;
	}
	.progressitem {
		font-size: 10px;
		width: 150px;
		height: 64px;
		background-color: #ffea00;
		border: 1px solid black;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		padding: 10px;
		margin-top: 5px;
	}
	:global(.progressitem.completed) {
		background-color: #a2cf6e !important;
	}
	:global(.progressitem.completed .progressitemts) {
		color: white !important;
	}
	.progressiteminfo {
		width: 100%;
		overflow-wrap: break-word;
		word-wrap: break-word;
		hyphens: auto;
	}
	.progressitemstatus {
		width: 100%;
		font-weight: bold;

	}
	.progressitemts {
		width: 100%;
		color: #999;
		font-style: italic;
	}
	.progressflowarrow {
		font-size: 40px;
		font-weight: bold;
		color: #666;
		height: 50px;
		width: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.pricinginfo {
		grid-area: ac;
	}
	.clientinfo {
		grid-area: ci;
	}
	.serviceinfo {
		grid-area: si;
	}
	.contractors {
		grid-area: cr;
	}
	.timesheetinfo {
		grid-area: ts;
	}
	.timesheetinfo th, .timesheetinfo td {
		padding: 4px 5px;
	}
	.map {
		grid-area: pi;
		width: 100%;
		height: 300px;
	}
	.additionalcomments {
		grid-area: ma;
	}
	.internalcomments {
		grid-area: ic;
	}
	.photoinfo {
      grid-area: py;
  }
	.section {
		border: 1px solid #1769aa;
	}
	.photo-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
  }
  .photo-item {
      display: flex;
      flex-direction: column;
      margin: 10px;
  }
	.photo{
		height: 150px;
		width: 150px;
	}
  .photo-thumbnail {
      height: 100%;
      width: 100%;
      max-height: 600px;
  }
	@media (max-device-width: 1024px),
	(max-width: 1023px) {
		.contentholder, .contentholder_crew {
			width: 100%;
			max-width: 100vw;
			margin-left: auto;
			margin-right: auto;
			display: grid;
			grid-template-columns: repeat(1, 1fr);
			grid-template-rows: auto;
			grid-template-areas: "bh"
				"si"
				"pi"
				"ci"
				"ac"
				"ic"
				"cr"
				"ma"
				"ts"
				"pr"
				"py";
			gap: 20px;
		}
		.buttonholder {
			width: 100%;
			display: flex;
			flex-direction: column;
		}
		.buttonholder button.action {
			width: 100%;
		}
		.progressholder {
			width: 100%;
			display: flex;
			flex-direction: column;
		}
		.progressitem {
			width: 100%;
			height: 25px;
			padding: 0px;
			background-color: #ffea00;
			border: 1px solid black;
			display: flex;
			flex-direction: row;
			text-align: left;
			align-items: center;
			margin-top: 5px;
			border-radius: 0px;
		}
		.progressitemts {
			text-align: right;
		}
		.progressflowarrow {
			font-size: 12px;
			font-weight: bold;
			color: #666;
			height: 12px;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.infoitem {
			width: 100%;
			display: flex;
			flex-direction: row;
		}
		.infoitem .infoitemtitle {
			width: 50%;
			font-weight: bold;
			text-align: left !important;
			overflow-wrap: break-word;
			word-wrap: break-word;
			hyphens: auto;
		}
		.infoitem .infoitemvalue {
			text-align: left;
			margin-left: 10px;
			overflow-wrap: break-word;
			word-wrap: break-word;
			hyphens: auto;
			width: 50%;
		}
		.pricinginfo .sectioninfo {
			width: 100%;
			display: flex;
			flex-direction: column;
		}
		.pricinginfo .leftcolumn {
			width: 100%;
			display: flex;
			flex-direction: column;
		}
		.serviceinfo .sectioninfo {
			width: 100%;
			display: flex;
			flex-direction: column;
		}
		.serviceinfo .leftcolumn {
			width: 100%;
			display: flex;
			flex-direction: column;
		}
		.serviceinfo .rightcolumn {
			width: 100%;
			display: flex;
			flex-direction: column;
		}
	}
</style>